import React from 'react';
import MetaTags from '../../components/layout/MetaTags';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import FadeInView from '../../components/FadeInView';
import { IoBookOutline, IoSchoolOutline, IoSchool } from 'react-icons/io5';
import { IoArrowUp } from 'react-icons/io5';
import { 
  Users, 
  CalendarCheck,
  Quotes,
  Hourglass
} from '@phosphor-icons/react';
import uSukaryadi from '../../assets/images/pejabat/u_sukaryadi.png';
import abiSaiful from '../../assets/images/pejabat/abi_saiful.png';
import zahYuyun from '../../assets/images/pejabat/zah_yuyun.png';
import uAliMafrohim from '../../assets/images/pejabat/u_ali.png';
import './About.css';

const lembagaData = [
  {
    icon: IoBookOutline,
    title: 'Pondok Pesantren',
    subtitle: 'Bahrul Ulum',
    description:
      'Kurikulum pesantren dengan program unggulan komprehensif. Tahfidz Al-Qur\'an, kajian kitab kuning, dan pengembangan bahasa Arab.',
    href: '#',
  },
  {
    icon: IoSchoolOutline,
    title: 'MTS Plus',
    subtitle: 'Bahrul Ulum',
    description:
      'Di bawah naungan Kementrian Agama. Memadukan pendidikan formal dengan nilai-nilai keislaman untuk lulusan unggul.',
    href: '#',
  },
  {
    icon: IoSchool,
    title: 'SMA Plus',
    subtitle: 'Bahrul Ulum',
    description:
      'Naungan Kemendikbud. Fokus pengembangan akademik dan karakter, mempersiapkan siswa untuk perguruan tinggi terbaik.',
    href: '#',
  },
];

const pejabatData = [
  {
    image: abiSaiful,
    name: 'Drs. H. Syaipul Zohri',
    position: 'Ketua Yayasan Bahrul Ulum',
  },
  {
    image: uSukaryadi,
    name: 'Sukaryadi, S.Pd.I',
    position: 'Kepala Pondok Pesantren',
  },
  {
    image: uAliMafrohim,
    name: 'Ali Mafrohim, S.Pd.I',
    position: 'Kepala MTs Plus',
  },
  {
    image: zahYuyun,
    name: 'Yuniarsih, M.Pd',
    position: 'Kepala SMA Plus',
  },
];

const pendiriData = [
  'Drs. H. Abu Hanifah',
  'H. Syamsul Bahri',
  'H. Syamsi Musthofa',
  'KH. Satah Helmy',
];

const ketuaYayasanHistory = [
  { periode: 'Pertama', nama: 'H. Syamsi Musthofa' },
  { periode: 'Kedua', nama: 'H. Tarmizi, MM' },
  { periode: 'Ketiga', nama: 'Ujang Farial SH, MM' },
];

const pengurusNow = [
  { jabatan: 'Ketua', nama: 'Drs. H. Saiful Zohri' },
  { jabatan: 'Wakil Ketua', nama: 'Rozali Romkhan, SH, MSi' },
  { jabatan: 'Sekretaris', nama: 'Drs. H. Murjadi' },
  { jabatan: 'Bendahara', nama: 'Muhammad Iqbal Nursyamsi, S.Pd' },
];

const About = () => {
  return (
    <div className="about-page">
      <MetaTags
        title="Tentang Kami - YBUS"
        description="Pelajari lebih lanjut tentang sejarah, visi misi, dan struktur pengurus Yayasan Bahrul Ulum Sungailiat."
      />
      <Header />

      <main>
        {/* Hero Section */}
        <section className="about-hero">
          <div className="container-tight">
            <FadeInView>
              <div className="about-hero-content">
                <span className="text-label about-hero-label">PROFIL YAYASAN</span>
                <h1 className="text-display about-hero-title">
                  Tentang
                  <br />
                  <span className="about-hero-title-muted">Kami</span>
                </h1>
                <p className="about-hero-desc">
                  Kenali lebih dekat sejarah, visi misi, dan struktur 
                  organisasi Yayasan Bahrul Ulum Sungailiat.
                </p>
              </div>
            </FadeInView>
          </div>
        </section>

        {/* Pejabat Section */}
        <section className="about-pejabat">
          <div className="container-tight">
            <FadeInView className="about-section-header">
              <span className="text-label about-section-label">PIMPINAN YAYASAN</span>
              <h2 className="text-headline about-section-title">
                Struktur
                <br />
                <span className="about-section-title-muted">Kepengurusan</span>
              </h2>
            </FadeInView>

            <div className="about-pejabat-grid">
              {pejabatData.map((pejabat, index) => (
                <FadeInView key={pejabat.name} delay={index * 0.1}>
                  <div className="about-pejabat-card">
                    <div className="about-pejabat-image-wrapper">
                      <img 
                        src={pejabat.image} 
                        alt={pejabat.name}
                        className="about-pejabat-image"
                      />
                    </div>
                    <div className="about-pejabat-info">
                      <h3 className="about-pejabat-name">{pejabat.name}</h3>
                      <p className="about-pejabat-position">{pejabat.position}</p>
                    </div>
                  </div>
                </FadeInView>
              ))}
            </div>
          </div>
        </section>

        {/* Sejarah & Profil - Storytelling Style */}
        <section className="about-sejarah">
          <div className="container-tight">
            {/* Section Header */}
            <FadeInView className="about-sejarah-header">
              <span className="text-label about-section-label">SEJARAH & PROFIL</span>
              <h2 className="text-headline about-section-title">
                Selayang <span className="about-section-title-muted">Pandang</span>
              </h2>
            </FadeInView>

            {/* Story Timeline - 4 Context Points */}
            <div className="about-story-timeline">
              <FadeInView direction="up" delay={0.1}>
                <div className="about-story-timeline-item">
                  <div className="about-story-timeline-marker">01</div>
                  <div className="about-story-timeline-content">
                    <p className="about-story-timeline-text">
                      Semakin cepat dan meluasnya arus globalisasi, transformasi dan telekomunikasi saat ini yang tentunya akan mempengaruhi pola hidup, pola perilaku baik yang positif maupun negatif di kalangan masyarakat.
                    </p>
                  </div>
                </div>
              </FadeInView>

              <FadeInView direction="up" delay={0.15}>
                <div className="about-story-timeline-item">
                  <div className="about-story-timeline-marker">02</div>
                  <div className="about-story-timeline-content">
                    <p className="about-story-timeline-text">
                      Terbatasnya tempat/pusat kajian agama Islam di Provinsi Bangka Belitung sementara mayoritas penduduk di provinsi ini beragama Islam.
                    </p>
                  </div>
                </div>
              </FadeInView>

              <FadeInView direction="up" delay={0.2}>
                <div className="about-story-timeline-item">
                  <div className="about-story-timeline-marker">03</div>
                  <div className="about-story-timeline-content">
                    <p className="about-story-timeline-text">
                      Tingginya minat masyarakat/orang tua untuk mendidik/menyekolahkan anaknya di pondok pesantren yang tentunya akan menjadi modal dasar mencetak generasi muda yang menguasai iptek dan imtaq.
                    </p>
                  </div>
                </div>
              </FadeInView>

              <FadeInView direction="up" delay={0.25}>
                <div className="about-story-timeline-item">
                  <div className="about-story-timeline-marker">04</div>
                  <div className="about-story-timeline-content">
                    <p className="about-story-timeline-text">
                      Terlalu ketatnya persaingan untuk diterima di perguruan tinggi negeri bagi anak-anak tamatan SMA, SMK, dan MA yang ada di Bangka Belitung khususnya Kabupaten Bangka.
                    </p>
                  </div>
                </div>
              </FadeInView>
            </div>

            {/* The Initiators */}
            <FadeInView direction="up" delay={0.3}>
              <div className="about-story-initiators">
                <span className="about-story-initiators-label">Atas dasar inilah</span>
                <h3 className="about-story-initiators-title">"Sang Inisiator"</h3>
                <p className="about-story-initiators-names">
                  Bapak Drs. H. Abu Hanifah, H. Syamsul Bachri, H. Syamsi Mustofa, BA meyakinkan Ir. Eko Maulana Ali, MSc., selaku Bupati Bangka mendukung pembangunan pusat kegiatan keagamaan seperti Islamic Centre.
                </p>
              </div>
            </FadeInView>

            {/* The Dialogue - Quote Card */}
            <FadeInView direction="up" delay={0.35}>
              <div className="about-story-dialogue">
                <div className="about-story-dialogue-header">
                  <Quotes weight="fill" />
                  <span>Adapun dialog dimaksud (antara Abu Hanifah dan Eko Maulana Ali)</span>
                </div>
                <blockquote className="about-story-dialogue-quote">
                  "Pak Bupati, kite ni lom ade pusat kegiatan keagamaan seperti Islamic Centre, mumpung Bapak agik jadi Bupati, jadilah untuk kenang-kenangan, karena Bupati-Bupati terdahulu seperti Pak Djardin membangun Masjid Agung, Pak Hariono mengaspal jalan-jalan di Bangka ini dan Pak Bustan Khalik membangun kantor Bupati yang ade saat ini, minta dukungannya serta solusi e nek mane kite mendirikan Islamic Centre Pak", ungkap Pak Abu Hanifah.
                </blockquote>
              </div>
            </FadeInView>

            {/* The Determination */}
            <FadeInView direction="up" delay={0.4}>
              <div className="about-story-determination">
                <p className="about-story-determination-text">
                  Hasrat mendirikan Islamic Centre tersebut kemudian menjadi tekad dan didukung oleh semua komponen masyarakat baik Pemerintah, perusahaan swasta, BUMN, ormas-ormas maupun perorangan.
                </p>
              </div>
            </FadeInView>

            {/* The Founding */}
            <FadeInView direction="up" delay={0.45}>
              <div className="about-story-founding">
                <div className="about-story-founding-content">
                  <p className="about-story-founding-text">
                    Dengan niat yang tulus dan semangat kebersamaan yang tinggi walau tantangan yang cukup berat akhirnya para pendiri Islamic Centre ini secara bertahap dapat mewujudkan pusat kajian agama Islam dengan nama Yayasan Bahrul Ulum Pondok Pesantren Islamic Centre tanggal 20 Oktober 1999.
                  </p>
                  <div className="about-story-founding-date">
                    <CalendarCheck weight="duotone" />
                    <span>20 Oktober 1999</span>
                  </div>
                </div>
              </div>
            </FadeInView>

            {/* Closing */}
            <FadeInView direction="up" delay={0.5}>
              <div className="about-story-closing">
                <p className="about-story-closing-text">
                  Alhamdulillah sampai saat ini terus berkembang sesuai tuntutan zaman.
                </p>
              </div>
            </FadeInView>

            {/* Pendiri List */}
            <FadeInView direction="up" delay={0.4}>
              <div className="about-pendiri-section">
                <h4 className="about-pendiri-title">Pendiri Yayasan</h4>
                <div className="about-pendiri-list">
                  {pendiriData.map((pendiri) => (
                    <span key={pendiri} className="about-pendiri-item">{pendiri}</span>
                  ))}
                </div>
                <p className="about-pendukung">
                  <strong>Pendukung:</strong> Ir. H. Eko Maulana Ali MSc
                </p>
              </div>
            </FadeInView>

            {/* Stats Row */}
            <FadeInView direction="up" delay={0.5}>
              <div className="about-story-stats">
                <div className="about-story-stat-item">
                  <div className="about-story-stat-icon">
                    <Hourglass weight="duotone" />
                  </div>
                  <div className="about-story-stat-number">25+</div>
                  <div className="about-story-stat-label">Tahun Mengabdi</div>
                </div>
                <div className="about-story-stat-item">
                  <div className="about-story-stat-icon">
                    <IoSchoolOutline />
                  </div>
                  <div className="about-story-stat-number">3</div>
                  <div className="about-story-stat-label">Unit Pendidikan</div>
                </div>
                <div className="about-story-stat-item">
                  <div className="about-story-stat-icon">
                    <Users weight="duotone" />
                  </div>
                  <div className="about-story-stat-number">1000+</div>
                  <div className="about-story-stat-label">Alumni</div>
                </div>
              </div>
            </FadeInView>
          </div>
        </section>

        {/* Visi Misi */}
        <section className="about-visimisi">
          <div className="container-tight">
            <FadeInView className="about-section-header">
              <span className="text-label about-section-label">ARAH & TUJUAN</span>
              <h2 className="text-headline about-section-title">
                Visi &
                <br />
                <span className="about-section-title-muted">Misi</span>
              </h2>
            </FadeInView>

            <div className="about-visimisi-grid">
              <FadeInView direction="left">
                <div className="about-visi-card">
                  <h3 className="about-visimisi-card-title">Visi</h3>
                  <p className="about-visi-text">
                    Terbentuknya generasi yang mumpuni ber-IPTEK dan IMTAQ untuk 
                    menata masa depan yang didukung oleh sumber daya manusia yang 
                    berkualitas, memiliki keunggulan daya saing, cerdas, berkepribadian, 
                    dan berakhlak mulia.
                  </p>
                </div>
              </FadeInView>

              <FadeInView direction="right">
                <div className="about-misi-card">
                  <h3 className="about-visimisi-card-title">Misi</h3>
                  <ol className="about-misi-list">
                    <li>Mengupayakan pengamalan ajaran Islam dalam segala bentuk kegiatan.</li>
                    <li>Menanamkan diri sebagai penggerak dan fasilitator kegiatan-kegiatan Islami.</li>
                    <li>Bahu-membahu untuk menimba ilmu pengetahuan dan teknologi yang sejalan dengan ajaran Islam.</li>
                    <li>Menjadi contoh dalam menciptakan ukhuwah Islamiyah.</li>
                  </ol>
                </div>
              </FadeInView>
            </div>
          </div>
        </section>

        {/* Struktur Pengurus */}
        <section className="about-struktur">
          <div className="container-tight">
            <FadeInView className="about-section-header">
              <span className="text-label about-section-label">ORGANISASI</span>
              <h2 className="text-headline about-section-title">
                Struktur
                <br />
                <span className="about-section-title-muted">Pengurus</span>
              </h2>
            </FadeInView>

            <div className="about-struktur-grid">
              {/* Sejarah Ketua */}
              <FadeInView>
                <div className="about-struktur-card">
                  <h3 className="about-struktur-card-title">Sejarah Ketua Yayasan</h3>
                  <div className="about-ketua-timeline">
                    {ketuaYayasanHistory.map((item, index) => (
                      <div key={item.periode} className="about-ketua-item">
                        <span className="about-ketua-periode">{item.periode}</span>
                        <span className="about-ketua-nama">{item.nama}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </FadeInView>

              {/* Pengurus Saat Ini */}
              <FadeInView delay={0.1}>
                <div className="about-struktur-card about-struktur-card-highlight">
                  <h3 className="about-struktur-card-title">Pengurus Saat Ini</h3>
                  <div className="about-pengurus-list">
                    {pengurusNow.map((item) => (
                      <div key={item.jabatan} className="about-pengurus-item">
                        <span className="about-pengurus-nama">{item.jabatan}</span>
                        <span className="about-pengurus-nama">{item.nama}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </FadeInView>
            </div>
          </div>
        </section>

        {/* Lembaga Section */}
        <section id="lembaga" className="about-lembaga">
          <div className="container-tight">
            <FadeInView className="about-section-header">
              <div className="about-lembaga-header-grid">
                <div>
                  <span className="text-label about-section-label">LEMBAGA PENDIDIKAN</span>
                  <h2 className="text-headline about-section-title">
                    Tiga Pilar
                    <br />
                    <span className="about-section-title-muted">Pendidikan Terpadu</span>
                  </h2>
                </div>
                <p className="about-lembaga-desc">
                  Kurikulum terintegrasi yang memadukan pendidikan agama, akademik, 
                  dan pengembangan karakter untuk membentuk generasi unggul.
                </p>
              </div>
            </FadeInView>

            <div className="about-lembaga-grid">
              {lembagaData.map((lembaga, index) => (
                <FadeInView key={lembaga.title} delay={index * 0.15}>
                  <a href={lembaga.href} className="about-lembaga-card">
                    <div className="about-lembaga-card-inner">
                      <div className="about-lembaga-icon-wrapper">
                        <lembaga.icon className="about-lembaga-icon" />
                      </div>
                      <div className="about-lembaga-card-content">
                        <div>
                          <h3 className="about-lembaga-card-title">{lembaga.title}</h3>
                          <span className="about-lembaga-card-subtitle">{lembaga.subtitle}</span>
                        </div>
                        <p className="about-lembaga-card-desc">{lembaga.description}</p>
                        <div className="about-lembaga-link">
                          <span>Selengkapnya</span>
                          <IoArrowUp className="about-lembaga-link-icon" />
                        </div>
                      </div>
                    </div>
                  </a>
                </FadeInView>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default About;
